import { render, staticRenderFns } from "./ContainerBanner.vue?vue&type=template&id=1c128e6c&scoped=true&"
import script from "./ContainerBanner.vue?vue&type=script&lang=js&"
export * from "./ContainerBanner.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBanner.vue?vue&type=style&index=0&id=1c128e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c128e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
